import { gsap } from 'gsap';

export function animations() {
	const toggleSettings = 'play none none none';
	const duration = 0.9;
	gsap.utils.toArray('.js-anim-fade-up').forEach((contentBlock) => {
		gsap.from(contentBlock, {
			y: 20,
			duration: duration,
			ease: 'power2.out',
			scrollTrigger: {
				trigger: contentBlock,
				start: 'top 90%',
				end: 'bottom 30%',
				toggleActions: toggleSettings,
			},
		});
		gsap.from(
			contentBlock,
			{
				autoAlpha: 0,
				duration: duration,
				ease: 'none',
				scrollTrigger: {
					trigger: contentBlock,
					start: 'top 90%',
					end: 'bottom 30%',
					toggleActions: toggleSettings,
				},
			},
			'-=0.7',
		);
	});

	gsap.utils.toArray('.js-anim-move-up').forEach((contentBlock) => {
		gsap.from(contentBlock, {
			y: 20,
			duration: duration,
			ease: 'power2.out',
			scrollTrigger: {
				trigger: contentBlock,
				start: 'top bottom',
				end: 'bottom 30%',
				toggleActions: toggleSettings,
			},
		});
	});
}
